import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderViscosityTestsCols: RenderScenarioExportCols = ({
  calcs,
  targetUnits
}) => {
  return [
    {
      section: "Viscosity Tests",
      label: "Live Oil Viscosity at Perf Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.fluidProperties.fluidPropertiesAtWellPerfs.value.oilViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Water Viscosity at Perf Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.fluidProperties.fluidPropertiesAtWellPerfs.value.waterViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Average Viscosity of Mix at Perf Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.fluidProperties.fluidPropertiesAtWellPerfs.value.liquidViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Live Oil Viscosity at Intake Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value: calcs.fluidProperties.fluidPropertiesAtIntake.value.oilViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Water Viscosity at Intake Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.fluidProperties.fluidPropertiesAtIntake.value.waterViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Average Viscosity of Mix at Intake Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.fluidProperties.fluidPropertiesAtIntake.value.liquidViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Live Oil Viscosity at Discharge Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.pumpCalculations.individual.value[
          calcs.descendingOrderPumps.value[0]?.id
        ]?.dischargeStageCalculations?.dischargeFluidPropertiesContext
          .fluidProperties.oilViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Water Viscosity at Discharge Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.pumpCalculations.individual.value[
          calcs.descendingOrderPumps.value[0]?.id
        ]?.dischargeStageCalculations?.dischargeFluidPropertiesContext
          .fluidProperties.waterViscosityCP
    },
    {
      section: "Viscosity Tests",
      label: "Average Viscosity of Mix at discharge Conditions",
      targetUnit: targetUnits.viscosityUnit,
      value:
        calcs.pumpCalculations.individual.value[
          calcs.descendingOrderPumps.value[0]?.id
        ]?.dischargeStageCalculations?.dischargeFluidPropertiesContext
          .fluidProperties.liquidViscosityCP
    }
  ];
};
